/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import Image from 'next/image';
import { observer, inject } from 'mobx-react';
import { useRouter } from 'next/router';
import Link from '@/components/common/Link';

const MainMenu = inject('studioStore')(observer(({ studioStore, items }) => {
  const router = useRouter();
  const { slug } = router.query;
  const [hoveredItem, setHoveredItem] = useState(null);

  const hoverSettings = studioStore?.settings?.header?.hover_settings;
  let classes = "font-semibold";

  if (hoverSettings?.container === "stamp") {
    classes = classes + " stamp-border stamp-border-xs over-trans-border";
  }

  const getSlugFromUrl = (url) => {
    try {
      const decodedUrl = decodeURIComponent(url);
      const urlSegments = decodedUrl.split('/').filter(Boolean);
      return urlSegments[urlSegments.length - 1];
    } catch (error) {
      console.error("Error decoding URL:", error);
      return url;
    }
  };

  // Organize items into parent and child structure
  const parentItems = items.filter(item => item.parent === "0");
  const childItems = items.filter(item => item.parent !== "0");

  const getChildItems = (parentId) => {
    return childItems.filter(item => item.parent === String(parentId));
  };

  return (
    <div className="flex items-center h-3/5 justify-center">
      <div className="flex items-center justify-center">
        <nav>
          <ul className="flex 2xl:space-x-4 xl:text-lg 2xl:text-2xl text-primary-studio">
            {parentItems.map((item, index) => {
              const itemSlug = getSlugFromUrl(item.url);
              const isActive = itemSlug === slug?.[0];
              const subItems = getChildItems(item.id);
              const hasChildren = subItems.length > 0;

              return (
                <li
                  key={index}
                  className={`menu-item ${classes} ${isActive ? 'active-menu' : ''} relative`}
                  onMouseEnter={() => setHoveredItem(String(item.id))}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <Link href={item.url} className="flex items-center font-semibold whitespace-nowrap">
                    {item.image_url && (
                      <Image src={item.image_url} alt={item.title} width={55} height={45} className="mr-2 hidden md:block" />
                    )}
                    {item.title}
                  </Link>
                  {hasChildren && hoveredItem === String(item.id) && (
                    <ul className="absolute left-0 rtl:right-0 rtl:left-auto top-full bg-white rounded-sm min-w-[200px] z-50 text-sm">
                      {subItems.map((subItem, subIndex) => (
                        <li key={`${index}-${subIndex}`} className="px-4 py-2 hover:bg-gray-100">
                          <Link href={subItem.url} className="block whitespace-nowrap">
                            {subItem.image_url && (
                              <Image src={subItem.image_url} alt={subItem.title} width={24} height={24} className="inline-block mr-2" />
                            )}
                            {subItem.title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
      {hoverSettings?.container === "stamp" ? (
        <style jsx global>{`
          .menu-item.stamp-border.stamp-border-xs {
            background-image: radial-gradient(2px, rgba(255, 255, 255, 0) 98%, rgba(255, 255, 255, 0)),
            linear-gradient(rgba(255, 255, 255, 0) 0px, rgba(255, 255, 255, 0) 0px);
            padding: 2px 7px 4px;
          }
          .menu-item.stamp-border.stamp-border-xs:hover,
          .menu-item.stamp-border.stamp-border-xs.active-menu {
            background-image: radial-gradient(2px, rgba(255, 255, 255, 0) 98%, rgba(255, 255, 255, 1)),
            linear-gradient(rgba(255, 255, 255, 1) 0px, rgba(255, 255, 255, 1) 0px);
          }
          @media (max-width: 64rem) {
            .menu-item.stamp-border.stamp-border-xs {
              padding: 2px 7px 4px;
            }
          }
        `}</style>
      ) : (
        <style jsx global>{`
          .menu-item:hover,
          .active-menu {
            background-color: ${hoverSettings?.background_color};
            color: ${hoverSettings?.text_color};
          }
          .menu-item ul {
            background-color: ${hoverSettings?.background_color || 'white'};
          }
          .menu-item ul li:hover {
            background-color: ${hoverSettings?.text_color || 'rgba(0,0,0,0.1)'};
            color: ${hoverSettings?.background_color || 'inherit'};
          }
        `}</style>
      )}
    </div>
  );
}));

export default MainMenu;
